var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4H12C10.4087 4 8.88258 4.63214 7.75736 5.75736C6.63214 6.88258 6 8.4087 6 10V38C6 39.5913 6.63214 41.1174 7.75736 42.2426C8.88258 43.3679 10.4087 44 12 44H36C37.5913 44 39.1174 43.3679 40.2426 42.2426C41.3679 41.1174 42 39.5913 42 38V22H30C28.4087 22 26.8826 21.3679 25.7574 20.2426C24.6321 19.1174 24 17.5913 24 16V4ZM42 18V17.656C41.9991 16.0655 41.3668 14.5405 40.242 13.416L32.586 5.756C31.4607 4.63144 29.9349 3.99981 28.344 4H28V16C28 16.5304 28.2107 17.0391 28.5858 17.4142C28.9609 17.7893 29.4696 18 30 18H42Z",
    fill: "#7E45F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.83d6c5af60cf4c3cdd73e05bea895911.svg";
export { ForwardRef as ReactComponent };